// extracted by mini-css-extract-plugin
export default {"root":"DataDictionary_root__lVPDF"};